import React from "react";
import { useImperativeHandle } from "react";

import { useTranslation } from "react-i18next";

const NationPicker = ({}, ref) => {
  const { t } = useTranslation();
  const [selectValue, setSelectValue] = React.useState(113);
  const onChange = (event) => {
    const value = event.target.value;
    setSelectValue(value);
    console.log(event.target.value);
  };
  useImperativeHandle(ref, () => ({
    getData: getData,
  }));
  const getData = () => {
    return selectValue;
  };
  return (
    <div>
      <label class="form-label" for="grid-Nation">
        {t("Nation")}
      </label>
      <select class="form-select" id="grid-Nation" name="grid-Nation" onChange={onChange} defaultValue={selectValue}>
        <option value="1">{t("Afghanistan")}</option>
        <option value="2">{t("Albania")}</option>
        <option value="3">{t("Algeria")}</option>
        <option value="4">{t("Andorra")}</option>
        <option value="5">{t("Angola")}</option>
        <option value="6">{t("Anguilla")}</option>
        <option value="7">{t("Antartide")}</option>
        <option value="8">{t("AntiguaeBarbuda")}</option>
        <option value="9">{t("AntilleOlandesi")}</option>
        <option value="10">{t("ArabiaSaudita")}</option>
        <option value="11">{t("Argentina")}</option>
        <option value="12">{t("Armenia")}</option>
        <option value="13">{t("Aruba")}</option>
        <option value="14">{t("Australia")}</option>
        <option value="15">{t("Austria")}</option>
        <option value="16">{t("Azerbaijan")}</option>
        <option value="17">{t("Bahamas")}</option>
        <option value="18">{t("Bahrain")}</option>
        <option value="19">{t("Bangladesh")}</option>
        <option value="20">{t("Barbados")}</option>
        <option value="21">{t("Belgio")}</option>
        <option value="22">{t("Belize")}</option>
        <option value="23">{t("Benin")}</option>
        <option value="24">{t("Bermuda")}</option>
        <option value="25">{t("Bielorussia")}</option>
        <option value="26">{t("Bhutan")}</option>
        <option value="27">{t("Bolivia")}</option>
        <option value="28">{t("BosniaErzegovina")}</option>
        <option value="29">{t("Botswana")}</option>
        <option value="30">{t("Brasile")}</option>
        <option value="31">{t("BruneiDarussalam")}</option>
        <option value="32">{t("Bulgaria")}</option>
        <option value="33">{t("BurkinaFaso")}</option>
        <option value="34">{t("Burundi")}</option>
        <option value="35">{t("Cambogia")}</option>
        <option value="36">{t("Camerun")}</option>
        <option value="37">{t("Canada")}</option>
        <option value="38">{t("CapoVerde")}</option>
        <option value="39">{t("Ciad")}</option>
        <option value="40">{t("Cile")}</option>
        <option value="41">{t("Cina")}</option>
        <option value="42">{t("Cipro")}</option>
        <option value="43">{t("CittadelVaticano")}</option>
        <option value="44">{t("Colombia")}</option>
        <option value="45">{t("Comore")}</option>
        <option value="46">{t("CoreadelNord")}</option>
        <option value="47">{t("CoreadelSud")}</option>
        <option value="48">{t("CostaRica")}</option>
        <option value="49">{t("Costad'Avorio")}</option>
        <option value="50">{t("Croazia")}</option>
        <option value="51">{t("Cuba")}</option>
        <option value="52">{t("Danimarca")}</option>
        <option value="53">{t("Dominica")}</option>
        <option value="54">{t("Ecuador")}</option>
        <option value="55">{t("Egitto")}</option>
        <option value="56">{t("Eire")}</option>
        <option value="57">{t("ElSalvador")}</option>
        <option value="58">{t("EmiratiArabiUniti")}</option>
        <option value="59">{t("Eritrea")}</option>
        <option value="60">{t("Estonia")}</option>
        <option value="61">{t("Etiopia")}</option>
        <option value="62">{t("FederazioneRussa")}</option>
        <option value="63">{t("Fiji")}</option>
        <option value="64">{t("Filippine")}</option>
        <option value="65">{t("Finlandia")}</option>
        <option value="66">{t("Francia")}</option>
        <option value="67">{t("Gabon")}</option>
        <option value="68">{t("Gambia")}</option>
        <option value="69">{t("Georgia")}</option>
        <option value="70">{t("Germania")}</option>
        <option value="71">{t("Ghana")}</option>
        <option value="72">{t("Giamaica")}</option>
        <option value="73">{t("Giappone")}</option>
        <option value="74">{t("Gibilterra")}</option>
        <option value="75">{t("Gibuti")}</option>
        <option value="76">{t("Giordania")}</option>
        <option value="77">{t("Grecia")}</option>
        <option value="78">{t("Grenada")}</option>
        <option value="79">{t("Groenlandia")}</option>
        <option value="80">{t("Guadalupa")}</option>
        <option value="81">{t("Guam")}</option>
        <option value="82">{t("Guatemala")}</option>
        <option value="83">{t("Guinea")}</option>
        <option value="84">{t("Guinea-Bissau")}</option>
        <option value="85">{t("GuineaEquatoriale")}</option>
        <option value="86">{t("Guyana")}</option>
        <option value="87">{t("GuyanaFrancese")}</option>
        <option value="88">{t("Haiti")}</option>
        <option value="89">{t("Honduras")}</option>
        <option value="90">{t("HongKong")}</option>
        <option value="91">{t("India")}</option>
        <option value="92">{t("Indonesia")}</option>
        <option value="93">{t("Iran")}</option>
        <option value="94">{t("Iraq")}</option>
        <option value="95">{t("IsoladiBouvet")}</option>
        <option value="96">{t("IsoladiNatale")}</option>
        <option value="97">{t("IsolaHeardeIsoleMcDonald")}</option>
        <option value="98">{t("IsoleCayman")}</option>
        <option value="99">{t("IsoleCocos")}</option>
        <option value="100">{t("IsoleCook")}</option>
        <option value="101">{t("IsoleFalkland")}</option>
        <option value="102">{t("IsoleFaroe")}</option>
        <option value="103">{t("IsoleMarshall")}</option>
        <option value="104">{t("IsoleMarianneSettentrionali")}</option>
        <option value="105">{t("IsoleMinoridegliStatiUnitid'America")}</option>
        <option value="106">{t("IsolaNorfolk")}</option>
        <option value="107">{t("IsoleSolomon")}</option>
        <option value="108">{t("IsoleTurkseCaicos")}</option>
        <option value="109">{t("IsoleVerginiAmericane")}</option>
        <option value="110">{t("IsoleVerginiBritanniche")}</option>
        <option value="111">{t("Israele")}</option>
        <option value="112">{t("Islanda")}</option>
        <option value="113">{t("Italia")}</option>
        <option value="114">{t("Kazakhistan")}</option>
        <option value="115">{t("Kenya")}</option>
        <option value="116">{t("Kirghizistan")}</option>
        <option value="117">{t("Kiribati")}</option>
        <option value="118">{t("Kuwait")}</option>
        <option value="119">{t("Laos")}</option>
        <option value="120">{t("Lettonia")}</option>
        <option value="121">{t("Lesotho")}</option>
        <option value="122">{t("Libano")}</option>
        <option value="123">{t("Liberia")}</option>
        <option value="124">{t("Libia")}</option>
        <option value="125">{t("Liechtenstein")}</option>
        <option value="126">{t("Lituania")}</option>
        <option value="127">{t("Lussemburgo")}</option>
        <option value="128">{t("Macao")}</option>
        <option value="129">{t("Macedonia")}</option>
        <option value="130">{t("Madagascar")}</option>
        <option value="131">{t("Malawi")}</option>
        <option value="132">{t("Maldive")}</option>
        <option value="133">{t("Malesia")}</option>
        <option value="134">{t("Mali")}</option>
        <option value="135">{t("Malta")}</option>
        <option value="136">{t("Marocco")}</option>
        <option value="137">{t("Martinica")}</option>
        <option value="138">{t("Mauritania")}</option>
        <option value="139">{t("Maurizius")}</option>
        <option value="140">{t("Mayotte")}</option>
        <option value="141">{t("Messico")}</option>
        <option value="142">{t("Moldavia")}</option>
        <option value="143">{t("Monaco")}</option>
        <option value="144">{t("Mongolia")}</option>
        <option value="145">{t("Montserrat")}</option>
        <option value="146">{t("Mozambico")}</option>
        <option value="147">{t("Myanmar")}</option>
        <option value="148">{t("Namibia")}</option>
        <option value="149">{t("Nauru")}</option>
        <option value="150">{t("Nepal")}</option>
        <option value="151">{t("Nicaragua")}</option>
        <option value="152">{t("Niger")}</option>
        <option value="153">{t("Nigeria")}</option>
        <option value="154">{t("Niue")}</option>
        <option value="155">{t("Norvegia")}</option>
        <option value="156">{t("NuovaCaledonia")}</option>
        <option value="157">{t("NuovaZelanda")}</option>
        <option value="158">{t("Oman")}</option>
        <option value="159">{t("PaesiBassi")}</option>
        <option value="160">{t("Pakistan")}</option>
        <option value="161">{t("Palau")}</option>
        <option value="162">{t("Panama")}</option>
        <option value="163">{t("PapuaNuovaGuinea")}</option>
        <option value="164">{t("Paraguay")}</option>
        <option value="165">{t("Peru")}</option>
        <option value="166">{t("Pitcairn")}</option>
        <option value="167">{t("PolinesiaFrancese")}</option>
        <option value="168">{t("Polonia")}</option>
        <option value="169">{t("Portogallo")}</option>
        <option value="170">{t("PortoRico")}</option>
        <option value="171">{t("Qatar")}</option>
        <option value="172">{t("RegnoUnito")}</option>
        <option value="173">{t("RepubblicaCeca")}</option>
        <option value="174">{t("RepubblicaCentroafricana")}</option>
        <option value="175">{t("RepubblicadelCongo")}</option>
        <option value="176">{t("RepubblicaDemocraticadelCongo")}</option>
        <option value="177">{t("RepubblicaDominicana")}</option>
        <option value="178">{t("Reunion")}</option>
        <option value="179">{t("Romania")}</option>
        <option value="180">{t("Ruanda")}</option>
        <option value="181">{t("SaharaOccidentale")}</option>
        <option value="182">{t("SaintKittseNevis")}</option>
        <option value="183">{t("SaintPierreeMiquelon")}</option>
        <option value="184">{t("SaintVincenteGrenadine")}</option>
        <option value="185">{t("Samoa")}</option>
        <option value="186">{t("SamoaAmericane")}</option>
        <option value="187">{t("SanMarino")}</option>
        <option value="188">{t("Sant'Elena")}</option>
        <option value="189">{t("SantaLucia")}</option>
        <option value="190">{t("SaoTomeePrincipe")}</option>
        <option value="191">{t("Senegal")}</option>
        <option value="192">{t("Kosovo")}</option>
        <option value="193">{t("Seychelles")}</option>
        <option value="194">{t("SierraLeone")}</option>
        <option value="195">{t("Singapore")}</option>
        <option value="196">{t("Siria")}</option>
        <option value="197">{t("Slovacchia")}</option>
        <option value="198">{t("Slovenia")}</option>
        <option value="199">{t("Somalia")}</option>
        <option value="200">{t("Spagna")}</option>
        <option value="201">{t("SriLanka")}</option>
        <option value="202">{t("StatiFederatidellaMicronesia")}</option>
        <option value="203">{t("StatiUnitid'America")}</option>
        <option value="204">{t("SudAfrica")}</option>
        <option value="205">{t("SudGeorgiaeIsoleSandwich")}</option>
        <option value="206">{t("Sudan")}</option>
        <option value="207">{t("Suriname")}</option>
        <option value="208">{t("SvalbardeJanMayen")}</option>
        <option value="209">{t("Svezia")}</option>
        <option value="210">{t("Svizzera")}</option>
        <option value="211">{t("Swaziland")}</option>
        <option value="212">{t("Tagikistan")}</option>
        <option value="213">{t("Tailandia")}</option>
        <option value="214">{t("Taiwan")}</option>
        <option value="215">{t("Tanzania")}</option>
        <option value="216">{t("TerritoriBritannicidell'OceanoIndiano")}</option>
        <option value="217">{t("TerritoriFrancesidelSud")}</option>
        <option value="218">{t("TerritoriPalestinesiOccupati")}</option>
        <option value="219">{t("TimorEst")}</option>
        <option value="220">{t("Togo")}</option>
        <option value="221">{t("Tokelau")}</option>
        <option value="222">{t("Tonga")}</option>
        <option value="223">{t("TrinidadeTobago")}</option>
        <option value="224">{t("Tunisia")}</option>
        <option value="225">{t("Turchia")}</option>
        <option value="226">{t("Turkmenistan")}</option>
        <option value="227">{t("Tuvalu")}</option>
        <option value="228">{t("Ucraina")}</option>
        <option value="229">{t("Uganda")}</option>
        <option value="230">{t("Ungheria")}</option>
        <option value="231">{t("Uruguay")}</option>
        <option value="232">{t("Uzbekistan")}</option>
        <option value="233">{t("Vanuatu")}</option>
        <option value="234">{t("Venezuela")}</option>
        <option value="235">{t("Vietnam")}</option>
        <option value="236">{t("WalliseFutuna")}</option>
        <option value="237">{t("Yemen")}</option>
        <option value="238">{t("Zambia")}</option>
        <option value="239">{t("Zimbabwe")}</option>
        <option value="240">{t("Serbia")}</option>
        <option value="241">{t("Montenegro")}</option>
        <option value="242">{t("TimorEst")}</option>
        <option value="243">{t("Guernsey")}</option>
      </select>
    </div>
  );
};

export default React.forwardRef(NationPicker);
